import reportsStoreConfig from './stores/reportsStoreConfig';

export default {
  reportsStoreConfig,
};
